// extracted by mini-css-extract-plugin
export default {"HeroText":"styles_HeroText__vcJep","HeroText2":"styles_HeroText2__YZo6p","Text":"styles_Text__VBCsT","float_up":"styles_float_up__+4G09"};